<div class="modal-header">
    <h3 class="modal-title">{{ projectdata.code }}</h3>
</div>
<div class="modal-body">
    <div class="dl-startup-popup__algemeen-blok">
        @if (projectdata.popup_standaard) {
            <div class="dl-startup-popup__standaardtekst-blok" translate>STARTUP.STANDAARDTEKST</div>
        }
        @if (projectdata.popup_tekst?.length) {
            <div>{{ projectdata.popup_tekst }}</div>
        }
    </div>
    <div class="dl-startup-popup__optionele-blokken">
        @if (projectdata.popup_onderdelen && projectdata.norm_foutfeedback) {
            <div>
                <span translate>STARTUP.FOUTFEEDBACK</span>&nbsp;<span class="dl-startup-popup__vraagteken">?</span>
            </div>
        }
        @if (projectdata.popup_onderdelen && (projectdata.feedb_beginwaarden || projectdata.feedb_feedbackloop)) {
            <div>
                <span translate>STARTUP.SIMULATIEFEEDBACK</span>&nbsp;<span class="dl-startup-popup__uitroepteken">!</span>
            </div>
        }
        @if (projectdata.popup_onderdelen && projectdata.norm_balk) {
            <div translate>STARTUP.NORMBALK</div>
        }
    </div>
</div>
<div class="modal-footer">
    @if (projectdata.startvideo) {
        <button class="btn btn-primary" (click)="startvideo()" translate>STARTUP.TOONVIDEO</button>
    }
    @if (userdata.nummodellen) {
        <button class="btn btn-primary" (click)="openmodel()" translate>STARTUP.GADOOR</button>
    }
    @if (userdata.nummodellen && projectdata.standaardmodel) {
        <button class="btn btn-primary" (click)="standaardmodel()" translate>STARTUP.BEGINOPNIEUW</button>
    }
</div>
